import React, { useEffect, useState } from "react";
import "./styles/heroes.css";
import "./styles/home.css";
import "./styles/mediaqueries.css";
import "./styles/items.css";
import logo from "../Assets/images/Logo_Square.png";
import { Link } from "react-router-dom";
import axios from "axios";
import parse from "html-react-parser";
import Footer from "../components/Footer";
import heroFrame from "../Assets/images/Hero_List_Thumb_Normal_Frame.png";
// import strength from "../Assets/images/Icon_Strength.png";
// import intelligence from "../Assets/images/Icon_Intelligence.png";
// import agility from "../Assets/images/Icon_Agility.png";
// import spirit from "../Assets/images/Icon_Spirit.png";
import trinkets from "../Assets/images/filter/Icon_Trinkets2_On.png";
import arcana from "../Assets/images/filter/Icon_Arcana2_On.png";
import beagents from "../Assets/images/filter/Icon_Beagents2_On.png";
import body from "../Assets/images/filter/Icon_Body2_On.png";
import boots from "../Assets/images/filter/Icon_Boots2_On.png";
import gloves from "../Assets/images/filter/Icon_Gloves2_On.png";
import helms from "../Assets/images/filter/Icon_Helms2_On.png";
import weapons from "../Assets/images/filter/Icon_Weapons2_On.png";
import filterBg from "../Assets/images/Hero_Sort_Bg.png";
import itemsFrame from "../Assets/images/Items_Frame.png";
import itemsFrameSelected from "../Assets/images/Hero_Skill_Hover_Select.png";

const Items = () => {
  const [itemData, setItemData] = useState(null);
  const [items, setItems] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [selectedAbility, setSelectedAbility] = useState("");
  const [selectedItemIndex, setSelectedItemIndex] = useState({
    index: -1,
    itemName: "",
  });
  const [specificItemStatus, setSpecificItemStatus] = useState({
    isLoading: false,
    data: null,
  });
  const [showDetails, setShowDetails] = useState(isPhone() ? false : true);

  const filterItems = (attributeType) => {
    setSelectedAbility(attributeType);
    if (selectedAbility === attributeType) {
      setItems(itemData);
      setSelectedAbility("");
      return;
    }
    const filteredItems = itemData?.filter(
      (item) => item.itemSlotName.toLowerCase() == attributeType.toLowerCase()
    );
    setItems(filteredItems);
    setSelectedItemIndex({ index: 0, itemName: filteredItems[0]?.itemName });
  };
  const itemHandler = (itemName, index) => {
    setShowDetails(true);
    setSelectedItemIndex({ index: index, itemName: itemName });
  };

  function formatDescription(description) {
    if (description) {
      let formattedDescription = description?.replace(
        /<#([a-fA-F0-9]{6})>/g,
        '<span style="color: #$1;">'
      );
      formattedDescription = formattedDescription.replace(
        /<\/color>/g,
        "</span>"
      );

      formattedDescription = formattedDescription.replace(/<u>/g, "<u>");
      formattedDescription = formattedDescription.replace(/<\/u>/g, "</u>");

      formattedDescription = formattedDescription.replace(
        /<link=\"{{[^}]*}}\">/g,
        ""
      );
      formattedDescription = formattedDescription.replace(/<\/link>/g, "");
      return formattedDescription;
    }
  }

  function isPhone() {
    const userAgent = navigator.userAgent.toLowerCase();
    return /iphone|ipod|android.*mobile|windows phone|blackberry|webos/.test(
      userAgent
    );
  }

  useEffect(() => {
    if (selectedItemIndex.index !== -1) {
      if (!selectedItemIndex.itemName) return;
      setSpecificItemStatus({ ...specificItemStatus, isLoading: true });
      axios
        .get(
          `https://cotp-game.azurewebsites.net/api/ItemRolls/GetSpecificItemByName?itemName=${selectedItemIndex.itemName}`
        )
        .then((res) => {
          setSpecificItemStatus({ isLoading: false, data: res?.data });
        });
    }
  }, [selectedItemIndex]);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Roshpit Champions II | Items";
    axios
      .get("https://cotp-game.azurewebsites.net/api/ItemRolls/GetAllItems")
      .then((res) => {
        setItemData(res?.data);
        setItems(res?.data);
        !isPhone() &&
          setSelectedItemIndex({ index: 0, itemName: res?.data[0]?.itemName });
      });
  }, []);

  useEffect(() => {
    setSelectedAbility("");
    if (searchValue.length > 0) {
      setItems(
        itemData?.filter((item) =>
          item.itemName.toLowerCase().includes(searchValue.toLowerCase())
        )
      );
    } else {
      setItems(itemData);
    }
  }, [searchValue]);
  return (
    <>
      <div className="heroes">
        <div className="heroes_heading_container container">
          <div className="heroes_heading">
            <p>Items</p>
            <span>
              Items are an essential part of the adventurer's toolkit. Using the
              right gear can mean the difference between defeating the evil of
              the Tanari or joining the fallen heroes in permanent rest. Using
              our item Tool, browse through all of the in-game items and see
              what combinations can truly give your hero the ultimate edge.
            </span>
          </div>
        </div>
        <div className="search container">
          <div className="filter_wrapper">
            <img src={filterBg} alt="" srcset="" />
            <div className="filter_content">
              <p>Filters</p>
              <div className="filter_ability_icons">
                <img
                  src={helms}
                  alt=""
                  srcset=""
                  className={`${
                    selectedAbility.toLowerCase() == "head" ? "active_icon" : ""
                  }`}
                  onClick={() => filterItems("Head")}
                />
                <img
                  src={body}
                  alt=""
                  srcset=""
                  className={`${
                    selectedAbility.toLowerCase() == "body" ? "active_icon" : ""
                  }`}
                  onClick={() => filterItems("Body")}
                />
                <img
                  src={weapons}
                  alt=""
                  srcset=""
                  className={`${
                    selectedAbility.toLowerCase() == "weapon"
                      ? "active_icon"
                      : ""
                  }`}
                  onClick={() => filterItems("Weapon")}
                />
                <img
                  src={gloves}
                  alt=""
                  srcset=""
                  className={`${
                    selectedAbility.toLowerCase() == "gloves"
                      ? "active_icon"
                      : ""
                  }`}
                  onClick={() => filterItems("Gloves")}
                />
                <img
                  src={boots}
                  alt=""
                  srcset=""
                  className={`${
                    selectedAbility.toLowerCase() == "boots"
                      ? "active_icon"
                      : ""
                  }`}
                  onClick={() => filterItems("Boots")}
                />
                <img
                  src={trinkets}
                  alt=""
                  srcset=""
                  className={`${
                    selectedAbility.toLowerCase() == "trinkets"
                      ? "active_icon"
                      : ""
                  }`}
                  onClick={() => filterItems("Trinket")}
                />
                <img
                  src={beagents}
                  alt=""
                  srcset=""
                  className={`${
                    selectedAbility.toLowerCase() == "consumable"
                      ? "active_icon"
                      : ""
                  }`}
                  onClick={() => filterItems("Consumable")}
                />
                <img
                  src={arcana}
                  alt=""
                  srcset=""
                  className={`${
                    selectedAbility.toLowerCase() == "key" ? "active_icon" : ""
                  }`}
                  onClick={() => filterItems("Key")}
                />
              </div>
            </div>
          </div>
          <div className="search_wrapper">
            <input
              type="text"
              placeholder="SEARCH"
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
            />
            <i className="bi bi-search"></i>
          </div>
        </div>
        {items?.length === 0 ? (
          <div
            style={{
              width: "100%",
              color: "#fff",
              display: "flex",
              justifyContent: "center",
              marginTop: "5rem",
              fontSize: "2rem",
            }}
          >
            <p className="gradient_heading">No Item Found</p>
          </div>
        ) : (
          <div className="items_wrapper container">
            {showDetails && items?.length > 0 ? (
              <div className={`items_details`}>
                {specificItemStatus.isLoading ? (
                  <div className="items_details_loader">
                    <div className="lds-ripple">
                      <div></div>
                      <div></div>
                    </div>
                  </div>
                ) : (
                  <div className="details_section">
                    <button
                      className="close_button"
                      onClick={() => setShowDetails(false)}
                    >
                      <i className="bi bi-x"></i>
                    </button>
                    <div className="details_top_section">
                      <div className="details_top_section_image item large">
                        <div className="item_img">
                          <img
                            src={specificItemStatus?.data?.image}
                            alt={specificItemStatus?.data?.itemName}
                          />
                        </div>
                      </div>
                      <div className="details_top_section_info">
                        <p className="details_top_section_info_name">
                          {specificItemStatus?.data?.itemName}
                        </p>
                        <p className="details_top_section_info_stat">
                          SLOT{" "}
                          <span>{specificItemStatus?.data?.itemSlotName}</span>
                        </p>
                        <p className="details_top_section_info_stat">
                          id <span>{specificItemStatus?.data?.itemEnum}</span>
                        </p>
                      </div>
                    </div>

                    {specificItemStatus?.data?.hasSpecial ? (
                      <>
                        <div className="details_top_section_ability">
                          <p className="details_top_section_ability_key">
                            SPECIAL ABILITY
                          </p>
                          <p className="details_top_section_ability_value">
                            {specificItemStatus?.data?.itemSpecialName}
                          </p>
                        </div>
                        <p className="details_top_section_ability_description">
                          {parse(
                            formatDescription(
                              specificItemStatus?.data?.itemSpecialDescription
                            )
                          )}
                        </p>
                      </>
                    ) : null}
                    {specificItemStatus?.data?.lore ? (
                      <p className="details_top_section_description">
                        {specificItemStatus?.data?.lore}
                      </p>
                    ) : null}
                    <table className="items_table">
                      <tr>
                        <th>Base Stats</th>
                        <th>min</th>
                        <th>max</th>
                      </tr>
                      <tr>
                        <td>Armor</td>
                        <td>{specificItemStatus?.data?.min_ItemArmor}</td>
                        <td>{specificItemStatus?.data?.max_ItemArmor}</td>
                      </tr>
                      <tr>
                        <td>Magic Armor</td>
                        <td>{specificItemStatus?.data?.min_ItemMagicArmor}</td>
                        <td>{specificItemStatus?.data?.max_ItemMagicArmor}</td>
                      </tr>
                      <tr>
                        <td>Armor Pierce</td>
                        <td>{specificItemStatus?.data?.min_ItemArmorPierce}</td>
                        <td>{specificItemStatus?.data?.max_ItemArmorPierce}</td>
                      </tr>
                      <tr>
                        <td>Spell Pierce</td>
                        <td>{specificItemStatus?.data?.min_ItemSpellPierce}</td>
                        <td>{specificItemStatus?.data?.max_ItemSpellPierce}</td>
                      </tr>
                    </table>
                    <table className="items_table">
                      <tr>
                        <th>Possible Modifiers</th>
                        <th>min</th>
                        <th>max</th>
                      </tr>
                      {specificItemStatus?.data?.itemMods.map((mod, index) => (
                        <tr key={index}>
                          <td>{mod.modName}</td>
                          <td>{mod.minValue}</td>
                          <td>{mod.maxValue}</td>
                        </tr>
                      ))}

                      <tr>
                        <td>Magic Armor</td>
                        <td>{specificItemStatus?.data?.min_ItemMagicArmor}</td>
                        <td>{specificItemStatus?.data?.max_ItemMagicArmor}</td>
                      </tr>
                      <tr>
                        <td>Armor Pierce</td>
                        <td>{specificItemStatus?.data?.min_ItemArmorPierce}</td>
                        <td>{specificItemStatus?.data?.max_ItemArmorPierce}</td>
                      </tr>
                      <tr>
                        <td>Spell Pierce</td>
                        <td>{specificItemStatus?.data?.min_ItemSpellPierce}</td>
                        <td>{specificItemStatus?.data?.max_ItemSpellPierce}</td>
                      </tr>
                    </table>
                  </div>
                )}
              </div>
            ) : null}
            <div className="heroes_container items">
              {items === null ? (
                <div className="video_overlay1">
                  <div className="lds-ripple">
                    <div></div>
                    <div></div>
                  </div>
                  <p>Loading Items...</p>
                </div>
              ) : (
                items?.map((item, index) => {
                  return (
                    //   <Link key={index} to={`/hero/${item.heroEnumValue}`}>
                    <div
                      key={index}
                      className="item"
                      onClick={() => itemHandler(item.itemName, index)}
                    >
                      {selectedItemIndex.index == index ? (
                        <img
                          className="items_frame_selected"
                          src={itemsFrameSelected}
                          alt=""
                          srcset=""
                        />
                      ) : (
                        <img
                          className="items_frame"
                          src={itemsFrame}
                          alt=""
                          srcset=""
                        />
                      )}
                      {/* <img
                        src={heroFrame}
                        className="hero-frame"
                        alt=""
                        srcset=""
                      /> */}
                      <div className="item_img">
                        <img src={item.image} alt={item.itemName} />
                        {/* <div className="hero_details">
                        <p className="">{item.heroEnum}</p>
                        {getAbilityIcon(item.primaryAttribute)}
                      </div> */}
                      </div>
                      {/* <span>{item.itemName}</span> */}
                    </div>
                    //   </Link>
                  );
                })
              )}
            </div>
          </div>
        )}
      </div>
      <Footer />
    </>
  );
};

export default Items;
